import type { FilterItem } from '@/features/fanfiction-filters/types/fanfiction-filters.types';
import { resolveCharacterFilterNavigate } from '@/features/fanfiction-filters/utils/resolve-character-filter-navigate';
import { toggleSelectedFilterId } from '@/features/fanfiction-filters/utils/toggle-selected-filter-id';
import { buildSelectedCharacterLabels } from '../../CharacterFilterList.utils';

interface CreateCharacterToggleHandlerParams {
  item: FilterItem;
  itemId: string;
  selectedCharacters: string[];
  selectedFandoms: string[];
  characterIdToName: Record<string, string>;
  characters: FilterItem[];
  onCharactersChange?: (characters: string[], selectedLabels?: Record<string, string>) => void;
  onSingleCharacterNavigate?: (characterId: string, fandomId: string) => void;
  onCharacterLabelCached?: (characterId: string, characterName: string) => void;
}

export const createCharacterToggleHandler = ({
  item,
  itemId,
  selectedCharacters,
  selectedFandoms,
  characterIdToName,
  characters,
  onCharactersChange,
  onSingleCharacterNavigate,
  onCharacterLabelCached,
}: CreateCharacterToggleHandlerParams) => {
  return () => {
    const updated = toggleSelectedFilterId(selectedCharacters, itemId);
    const labelSource: Record<string, string> = {
      ...characterIdToName,
      [itemId]: item.name,
    };
    const selectedLabels = buildSelectedCharacterLabels(updated, labelSource, characters);
    const navigateResult = resolveCharacterFilterNavigate({
      updatedCharacterIds: updated,
      selectedFandomIds: selectedFandoms,
      characterFandomId: item.fandomId,
    });

    if (navigateResult.mode === 'single-permalink') {
      onSingleCharacterNavigate?.(navigateResult.characterId, navigateResult.fandomId);
    } else {
      onCharactersChange?.(navigateResult.characterIds, selectedLabels);
    }

    if (!characterIdToName[itemId]) {
      onCharacterLabelCached?.(itemId, item.name);
    }
  };
};

export const createPermalinkNavigateHandler = (onToggle: () => void) => {
  return (event: { preventDefault: () => void }) => {
    event.preventDefault();
    onToggle();
  };
};
